<template>
	<div class="layout-topbar">
		<router-link to="/" class="layout-topbar-logo">
			<img alt="Logo" :src="topbarImage()" />
		</router-link>
		<button class="p-link layout-menu-button layout-topbar-button" @click="onMenuToggle">
			<i class="pi pi-bars"></i>
		</button>

		<button class="p-link layout-topbar-menu-button layout-topbar-button" v-styleclass="{
			selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein',
			leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true
		}">
			<i class="pi pi-ellipsis-v"></i>
		</button>
		<ul class="layout-topbar-menu hidden lg:flex origin-top">
			<li>
				<label>
					<span v-bind:style="{ 'font-weight': 'bold' }">Logged in as</span>
					<p>{{ first_name+' '+last_name }}</p>
				</label>
			</li>
			<li>
				<router-link class="p-link layout-topbar-button" v-tooltip.bottom="'Library'" to="/library">
					<i class="pi pi-book"></i>
					<span>Library</span>
				</router-link>
			</li>
			<li>
				<DefaultCompanyPopup/>
			</li>
			<li>
				<button class="p-link layout-topbar-button" v-tooltip.bottom="'Logout'" @click="logout()">
					<i class="pi pi-sign-out"></i>
					<span>Logout</span>
				</button>
			</li>
		</ul>
	</div>
</template>

<script>
import DefaultCompanyPopup from "@/shared/components/DefaultCompanyPopup.vue";
import ApiService from "../../service/api/ApiService";
import authStore from "../../core/services/authStore/authStore";

export default {
	emits: ['show-toast'],
	data(){
		return {
			first_name: authStore.getters.userData.first_name,
			last_name: authStore.getters.userData.last_name
		}
	},
	created() {
		this.apiAuthService = new ApiService().apiAuthService;
		if(authStore.getters.showToast.severity){
			setTimeout(() => {
				this.showGeneralToast();	
			}, 1000);
        }
	},
	methods: {
		onMenuToggle(event) {
			this.$emit("menu-toggle", event);
		},
		onTopbarMenuToggle(event) {
			this.$emit("topbar-menu-toggle", event);
		},
		topbarImage() {
			return this.$appState.darkTheme ? "/layout/images/logo-white.png" : "/layout/images/logo-dark.png";
		},
		async logout() {
			try {
				authStore.commit('logoutIsAuth',false);
			} catch (error) {
				console.log(error);
			}
		},
		showGeneralToast(){
			const dataToast = authStore.getters.showToast
            this.$emit('show-toast',dataToast.severity,dataToast.title,'')
            authStore.commit('setShowToast',{})
		}
	},
	computed: {
		darkTheme() {
			return this.$appState.darkTheme;
		}
	},
	components: { DefaultCompanyPopup }
}
</script>